export default {
  playerPhotoContainer: {
    cursor: 'pointer',
  },
  playerThanks: {
    height: '300px',
    width: '300px',
    mt: '-15px',
  },
  playerForm: {
    width: '190px',
    height: '190px',
  },
  playerImage: {
    objectFit: 'contain',
  },
  playerNameAndButtonContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  playerNameContainer: {
    display: 'flex',
    flexDirection: ['row', 'column'],
    flexWrap: ['wrap', 'no-wrap'],
    gap: ['5px', '5px', '2px'],
    justifyContent: 'center',
    alignItems: 'center',
    py: ['0px', '10px', '10px'],
  },
  playerSurname: {
    color: 'tmBlue',
    fontFamily: 'bold',
    fontSize: ['22px', '22px', '30px'],
    fontWeight: 900,
    mt: ['2vh', '2vh', '0px'],
    textTransform: 'uppercase',
    lineHeight: ['auto', 'auto', '30px'],
  },
  thanksPlayer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    my: '40px',
  },
  votedPlayerContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    m5vhb: '50px',
  },
  votePlayerContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    height: ['auto', '400px'],
    '&:last-child': {
      mb: ['100px', '50px', 'auto'],
    },
  },
}
